import { ReactElement, useCallback } from 'react';
import styles from '@/styles/pages/home/application-page.module.less';
import Image from '@/components/LocalImage';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'antd';
import { mergeClasses } from '@/utils';
import { useTranslation } from '@/services';
const ApplicationPage = (): ReactElement => {
    const { t } = useTranslation('home', 'home.application');
    const navigate = useNavigate();
    const ToWitePaper = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://aicade-galaxy.gitbook.io/white-paper';
        }
    }, []);
    const goAppCenter = useCallback(() => {
        navigate('/admin/home');
    }, [navigate]);
    return (
        <div className={styles['content']}>
            <div className={styles['content-bg']}>
                <div className="left-style"></div>
                <div className={styles['to-banner-page']}>
                    <Link to="/">
                        <div className="flex">
                            <Image name="left-icon" type="svg" dir="/images/home"></Image>
                            <p className="ml-1">{t('go-back')}</p>
                        </div>
                        <div className={styles['lable']}>{t('discover-more')}</div>
                    </Link>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div className={styles['four-mt-10']}>
                        <Image className={styles['mini-title-dis']} name="four-title" type="svg" dir="/images/home"></Image>
                    </div>
                    <div className={styles['four-statistics']}>
                        <Row justify="space-evenly">
                            <Col className={mergeClasses(styles['gutter-row'], styles['left-tag'])} span={6}>
                                <div>
                                    <div>
                                        <Image className={styles['four-statistics-number']} name="35K+" type="svg" dir="/images/home"></Image>
                                    </div>
                                    <div className={styles['four-statistics-value']}>{t('ganworks')}</div>
                                </div>
                            </Col>
                            <Col className={styles['gutter-row']} span={2}>
                                <div style={{ border: '1px solid #00000033', height: '12vh', width: '1px' }}></div>
                            </Col>
                            <Col className={styles['gutter-row']} span={4}>
                                <div>
                                    <div>
                                        <Image className={styles['four-statistics-number']} name="2K+" type="svg" dir="/images/home"></Image>
                                    </div>
                                    <div className={styles['four-statistics-value']}>{t('auctions')}</div>
                                </div>
                            </Col>
                            <Col className={styles['gutter-row']} span={2}>
                                <div style={{ border: '1px solid #00000033', height: '12vh', width: '1px' }}></div>
                            </Col>
                            <Col className={mergeClasses(styles['gutter-row'], styles['right-tag'])} span={6}>
                                <div>
                                    <div>
                                        <Image className={styles['four-statistics-number']} name="500K+" type="svg" dir="/images/home"></Image>
                                    </div>
                                    <div className={styles['four-statistics-value']}>{t('players')}</div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className={styles['four-unmit']}>
                        <div className={styles['four-unmit-div']}>
                            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', textAlign: 'left' }}>
                                <Image name="hurt" type="svg" dir="/images/home"></Image>
                                <div className={styles['play']}>
                                    <div className={styles['play-bg']}>
                                        <div className={styles['go-play']}>
                                            <div className={styles['go']}>{t('go')}</div>
                                            <div className={mergeClasses(styles['play-icon'], styles['play-icon-hover'])}>
                                                <ArrowRightOutlined style={{ fontSize: '12px', fontFamily: 'Montserrat-Bold', marginLeft: '6px', color: '#fff' }} />
                                                <div style={{ marginRight: '6px' }}>{t('play')}</div>
                                            </div>
                                            <div onClick={goAppCenter} className={mergeClasses(styles['play-hover'], styles['play-icon'])}>
                                                {t('play')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles['umit-style']}>
                                <div className={styles['remark']}>
                                    <div className={styles['level']}>{t('level')}</div>
                                    <div className={styles['fps']}>{t('fps')}</div>
                                    <div className={styles['age']}>{t('age')}</div>
                                    <div className="flex">
                                        <div className={styles['level']}>{t('players-number')}</div>
                                        <div className={styles['players']}>{t('Players')}</div>
                                    </div>
                                </div>
                                <Button onClick={() => ToWitePaper()} className={styles['umint-btn']}>
                                    {t('btn-name')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right-style"></div>
            </div>
        </div>
    );
};

export default ApplicationPage;
